module.exports = __webpack_public_path__ + "img/slot_pg.49675ba2.png";